import axiosHttp from "./interceptor.service";

const saveHrLoginStatus = (payload) => {
    return axiosHttp.post("/feedback/saveHrLoginStatus", payload);
};

const checkHrLoginStatusToday = (hrId) => {
    return axiosHttp.get(`/feedback/getHrLoginStatusToday?hrId=${hrId}`);
};

const getHrLoginStatusReport = (params) => {
    return axiosHttp.get("/feedback/getHrLoginStatusReport", { params });
};

const assignHrResponsibility = (payload) => {
    return axiosHttp.post("/feedback/assignHrResponsibility", payload);
};

export default {
    saveHrLoginStatus,
    checkHrLoginStatusToday,
    getHrLoginStatusReport,
    assignHrResponsibility,
};

